import { Tag } from "antd";
import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** TREASURY API CONFIG                                                       ***!
  \*******************************************************************************/

export const apiConfig = {
  InterBankPlacement: BOM.baseUrl("interbankplacementproducts", "treasury"),
  moneymarketproducts: BOM.baseUrl("moneymarketproducts", "treasury"),

  // BOND PRODUCTS
  GetBondProduct: BOM.baseUrl("bondproducts", "treasury"),
  GetBondProducts: BOM.baseUrl("bondproducts", "treasury"),
  AddBondProduct: BOM.baseUrl("bondproducts", "treasury"),
  BondProductTemplate: BOM.baseUrl("bondproducts/template", "treasury"),
  EditBondProduct: BOM.baseUrl("bondproducts", "treasury"),
  FloatingRates: BOM.baseUrl("floatingrates"),
  SearchFloatingRates: BOM.baseUrl("floatingrates?name="),

  TreasuryBillProducts: BOM.baseUrl("treasurybillproducts", "treasury"),
  TreasuryBillProdTemplate: BOM.baseUrl(
    "treasurybillproducts/template",
    "treasury"
  ),
  TreasuryBillAddProduct: BOM.baseUrl("treasurybillproducts", "treasury"),
  TreasuryBillEditProduct: BOM.baseUrl("treasurybillproducts", "treasury"),
  TreasuryBillProduct: BOM.baseUrl("treasurybillproducts", "treasury"),
  RestrictionEndpoint: BOM.baseUrl("offices", "treasury"),
  InterBankPlacementTemplate: BOM.baseUrl(
    "interbankplacementproducts/template",
    "treasury"
  ),
};

/*!*******************************************************************************!
  !*** TREASURY LABEL CONFIG                                                       ***!
  \*******************************************************************************/

export const labelConfig = {
  id: "ID",
  name: "Name",

  // BOND
  bond: "Bond",
  viewBond: "Bond Details",
  addBond: "New Bond",
  updateBond: "Update Bond",
  productListing: "Product Listing",
  createBondTitle: "Bond Product",
  createBond: "Create Product...",
  editBond: "Update Product...",
  newBondMsg: "Bond was successfully created",

  // INTERBANK PLACEMENT
  interBankPlacement: "Interbank Placement",
  manageInterBankPlacement: "Interbank Placement",
  manageInterBankPlacementDetails: "Interbank Placement Details",
  newInterBankPlacement: "New Interbank Placement",
  detailInterBankPlacement: "Interbank Placement Detail",
  editInterBankPlacement: "Update Interbank Placement",
  createProduct: "Create New Product ...",
  updateProduct: "Update Product ...",

  // TREASURY BILL
  productName: "Product Name",
  instrument: "Instrument",
  currency: "Currency",
  tenorSupported: "Tenor Supported",
  issuer: "Issuer",
  status: "Status",
  treasuryBill: "Treasury Bill",
  generalInfo: "General Information",
  productInfo: "Product Information",
};

/*!*******************************************************************************!
    !*** OPERATIONS STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],

  // BOND
  bondItems: [{ title: labelConfig.bond }],
  newBondItems: [
    { title: <Link to="/bond-product">{labelConfig.bond}</Link> },
    {
      title: labelConfig.addBond,
    },
  ],
  viewBondItems: [
    { title: <Link to="/bond-product">{labelConfig.bond}</Link> },
    {
      title: labelConfig.viewBond,
    },
  ],
  editBondItems: [
    { title: <Link to="/bond-product">{labelConfig.bond}</Link> },
    {
      title: labelConfig.updateBond,
    },
  ],
  tempProducts: [
    {
      instrumentName: "NGN Treasury Bills",
      currencyName: "Pound Sterling (£)",
      issuerName: "Central Bank of Nigeria (CBN)",
      tenorSupportedName: "91 days",
      // ----
      key: 1,
      productName: "Corporate Bill",
      productCode: "3212389",
      instrument: 1,
      currency: 1,
      tenorSupported: 1,
      issuer: 1,
      status: "active",
      productCategory: 1,
      productCurrency: 1,
      restriction: 1,
      securityType: 1,
      tenor: 1,
      minimumInvestment: "1000",
      defaultInvestment: "1000",
      investmentIncrement: "1000",
      interestType: 1,
      redemptionMode: 1,
      allowEarlyRedemption: 1,
      pricingMethod: 1,
      pricingFrequency: 1,
      discountRate: "10",
      interestRateSource: 1,
      interestRateBasis: 1,
      accrualMethod: 1,
      debitSourceAccount: 1,
      settlementDate: 1,
      maturityProceeds: 1,
      rolloverOption: 1,
      investmentControlAccount: 1,
      accruedInterestAccount: 1,
      interestIncomeAccount: 1,
      customerPayableAccount: 1,
      startDate: "2025-01-15",
      endDate: "2030-01-15",
    },
  ],

  statusLabels: [
    { label: "All Status", value: "Status" },
    { label: "Active", value: "Active" },
    { label: "Pending", value: "Pending" },
    { label: "Disabled", value: "Disabled" },
    // { label: "Approved", value: "Approved" },
    // { label: "Matured", value: "Matured" },
    { label: "Expired", value: "Expired" },
    // { label: "Rejected", value: "Rejected" },
    { label: "Closed", value: "Closed" },
  ],

  // INTERBANK PLACEMENT
  summaryInterBankPlacement: [{ title: labelConfig.interBankPlacement }],

  createInterBankPlacement: [
    {
      title: (
        <Link to="/interbank-placement">{labelConfig.interBankPlacement}</Link>
      ),
    },
    {
      title: labelConfig.newInterBankPlacement,
    },
  ],

  interBankPlacementItems: [{ title: labelConfig.interBankPlacement }],
  newInterBankPlacementItems: [
    {
      title: (
        <Link to="/interbank-placement">{labelConfig.interBankPlacement}</Link>
      ),
    },
    {
      title: labelConfig.newInterBankPlacement,
    },
  ],
  viewInterBankPlacementItems: [
    {
      title: (
        <Link to="/interbank-placement">{labelConfig.interBankPlacement}</Link>
      ),
    },
    {
      title: labelConfig.detailInterBankPlacement,
    },
  ],
  editInterBankPlacementItems: [
    {
      title: (
        <Link to="/interbank-placement">{labelConfig.interBankPlacement}</Link>
      ),
    },
    {
      title: labelConfig.editInterBankPlacement,
    },
  ],

  // TREASURY BILL
  manageBreadcrumbItems: [{ title: labelConfig.treasuryBill }],
  createTreasuryBillBreadcrumbItems: [
    { title: <Link to="/treasury-bill">{labelConfig.treasuryBill}</Link> },
    { title: "Create new product" },
  ],
  updateTreasuryBillBreadcrumbItems: [
    { title: <Link to="/treasury-bill">{labelConfig.treasuryBill}</Link> },
    { title: "Update product" },
  ],
  ViewTreasuryBillBreadcrumbItems: [
    { title: <Link to="/treasury-bill">{labelConfig.treasuryBill}</Link> },
    { title: "Treasury Bill Detail" },
  ],
  currencyOptions: [
    { value: 1, label: "Pound Sterling (£)" },
    { value: 2, label: "US Dollar ($)" },
    { value: 3, label: "Euro (€)" },
    { value: 4, label: "Belize Dollar (BZ$)" },
    { value: 5, label: "Nigeria Naira (₦)" },
    { value: 6, label: "South Africa Rand (R)" },
  ],
  productCategoryOptions: [
    { value: 1, label: "Government" },
    { value: 2, label: "Investment" },
  ],
  restriction: [
    { value: 1, label: "All Branches" },
    { value: 2, label: "Head Office" },
  ],
  instrumentOptions: [
    { value: 1, label: "NGN Treasury Bills" },
    {
      value: 2,
      label: "Nigerian Treasury Bill (NTB)",
    },
  ],
  tenorSupported: [
    { value: 1, label: "91 days" },
    { value: 2, label: "182 days" },
    { value: 3, label: "364 days" },
  ],
  interestType: [
    { value: 1, label: "Zero Coupon" },
    { value: 2, label: "Non-Coupon Bearing" },
  ],
  redemptionMode: [
    { value: 1, label: "At Maturity" },
    { value: 2, label: "Monthly" },
  ],

  securityType: [
    { value: 1, label: "Zero Coupon" },
    { value: 2, label: "Discount" },
  ],
  pricingMethod: [{ value: 1, label: "Discount Yield Based" }],
  issuer: [{ value: 1, label: "Central Bank of Nigeria (CBN)" }],
  treasuryBillsStatusData: [
    // {
    //   key: "1",
    //   value: undefined,
    //   label: "Status",
    // },
    // {
    //   key: "2",
    //   value: "closed",
    //   label: "Closed",
    // },

    // {
    //   key: "3",
    //   value: "matured",
    //   label: "Matured",
    // },

    // {
    //   key: "4",
    //   value: "rejected",
    //   label: "Rejected",
    // },
    // {
    //   key: "5",
    //   value: "prematureclosed",
    //   label: "Premature Closed",
    // },
    // {
    //   key: "6",
    //   value: "withdrawnbyapplicant",
    //   label: "Withdrawn By Applicant",
    // },
    {
      key: "1",
      value: undefined,
      label: "Status",
    },
    {
      key: "2",
      value: "pending",
      label: "Submitted And Pending Approval",
    },
    {
      key: "3",
      value: "active",
      label: "Active",
    },
    {
      key: "4",
      value: "closed",
      label: "Closed",
    },
    {
      key: "5",
      value: "disabled",
      label: "Disabled",
    },
  ],
  pricingFrequency: [{ value: 1, label: "Per auction" }],
  interestRateSource: [
    { value: 1, label: "Central Bank Auction" },
    { value: 2, label: "Manual" },
  ],
  interestRateBasis: [
    {
      // value: "Actual/364",
      label: "Actual/365 (Daily accrual based on 356 days",
      value: 1,
    },
    {
      // value: "Actual/Actual",
      label: "Actual/Actual (Daily accrual based on calendar days",
      value: 2,
    },
    {
      // value: "Actual/360",
      label: "Actual/360 (Used for some money market instruments",
      value: 3,
    },
    {
      value: 4,
      label: "30/360 (Standard for bond markets)",
    },
    { value: 5, label: "Actual/364" },
  ],
  accrualMethod: [
    {
      // value: "straightLine",
      label: "Straight Line Method",
      value: 1,
    },
    {
      // value: "ci",
      value: 2,
      label: "Compound Interest (CI)",
    },
    {
      // value: "ei",
      value: 3,
      label: "Effective Interest",
    },
  ],
  debitSourceAccount: [
    {
      // value: "CustomerLinked",
      value: 1,
      label: "Customer Linked Account",
    },
    {
      // value: "gl",
      value: 2,
      label: "GL Account",
    },
  ],
  settlementDate: [
    {
      // value: "auctionSettlement",
      label: "Auction Settlement Date (T+2 by CBN)",
      value: 1,
    },
  ],
  maturityProceeds: [
    {
      // value: "auto-credit",
      value: 1,
      label: "Auto-credit to linked account",
    },
  ],
  rolloverOption: [
    {
      // value: "manual",
      label: "Manual",
      value: false,
    },
    { label: "Auto", value: true },
  ],
  investmentControlAccount: [{ value: 1, label: "GL for investment control" }],
  accruedInterestAccount: [
    {
      // value: "GL",
      label: "GL for accrued interest",
      value: 1,
    },
  ],
  interestIncomeAccount: [
    {
      // value: "GL",
      label: "GL for interest income",
      value: 1,
    },
  ],
  customerPayableAccount: [
    {
      // value: "GL",
      label: "GL for customer Payable",
      value: 1,
    },
  ],

  renderStatus: (status) => {
    const getColors = () => {
      switch (status.toLowerCase()) {
        case "active":
          return {
            color: "#067647",
            backgroundColor: "#ECFDF3",
            borderColor: "#ABEFC6",
          };
        case "closed":
          return {
            backgroundColor: "#FEF3F2",
            color: "#B42318",
            borderColor: "1px solid #FECDCA",
          };
        case "disabled":
          return {
            color: "#344054",
            backgroundColor: "#F9FAFB",
            borderColor: "#EAECF0",
          };
        case "mature":
          return {
            color: "#175CD3",
            backgroundColor: "#EFF8FF",
            borderColor: "#B2DDFF",
          };
        case "rejected":
          return {
            color: "#B42318",
            backgroundColor: "#FEF3F2",
            borderColor: "#FECDCA",
          };
        case "approved":
          return {
            color: "#3538CD",
            backgroundColor: "#EEF4FF",
            borderColor: "#C7D7FE",
          };
        case "prematureclosed":
          return {
            color: "#363F72",
            backgroundColor: "#F8F9FC",
            borderColor: "#D5D9EB",
          };
        case "withdrawnbyapplicant":
          return {
            color: "#026AA2",
            backgroundColor: "#F0F9FF",
            borderColor: "#B9E6FE",
          };
        case "submitted&pendingapproval":
          return {
            color: "#5925DC",
            backgroundColor: "#D9D6FE",
            borderColor: "#ABEFC6",
          };

        default:
          return {
            color: "#5925DC",
            backgroundColor: "#F4F3FF",
            borderColor: "#D9D6FE",
          };
      }
    };
    const { color, backgroundColor, borderColor } = getColors(status);
    return (
      <Tag
        style={{
          color,
          backgroundColor,
          borderColor,
          borderRadius: 9999,
        }}
      >
        {status}
      </Tag>
    );
  },
};

export function capitalizeFirstLetter(word) {
  if (!word || typeof word != "string") return "";
  return word.charAt(0).toUpperCase() + word.slice(1);
}
